package com.exura.features.plandefinition.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class PlanContentSummary(
    val title: String,
    val description: String,
    val imageUrl: String?,
    val planDuration: Int,
    val numberInstruction: Int,
    val numberPersistent: Int,
    val numberQuestion: Int,
    val numberFloating: Int,
)
